<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ this.grade.name }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0 text-uppercase">
                                    Mata Pelajaran
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body py-0">
                        <div class="row">
                            <div class="col-12 col-sm-6 border-bottom py-3" v-for="gradeSubject in gradeSubjects">
                                <router-link v-bind:to="{ name: 'forum/category', params: {id: gradeSubject.id} }" class="font-weight-bold h4 mb-1">{{ gradeSubject.subject.name }}</router-link>
                                <div class="row text-muted">
                                    <div class="col">
                                        {{ gradeSubject.subtitle }}
                                    </div>
                                </div>
                                <div class="row text-muted">
                                    <div class="col-auto">
                                        Jumlah Materi: {{ gradeSubject.totalTeachingMaterials }}
                                    </div>
                                    <div class="col-auto">
                                        Jumlah Thread: {{ gradeSubject.totalThreads }}
                                    </div>
                                    <div class="col-auto">
                                        Solved Thread: {{ gradeSubject.solvedThreads }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "ForumSubject",
        computed: mapState([
            'term'
        ]),
        watch: {
            term() {
                this.fetchData();
            }
        },
        data() {
            return {
                grade: {},
                gradeSubjects: []
            };
        },
        methods: {
            fetchData() {
                this.axios.get(process.env.API_URL + '/grade-subject', {params: {gradeID: this.grade.id, termID: this.term.id}}).then(response => {
                    this.gradeSubjects = response.data.data;
                });
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/grade/' + this.$route.params.id).then(response => {
                this.grade = response.data.data;

                this.fetchData();

                document.title = 'Forum - ' + this.grade.name + ' | ' + process.env.APP_NAME;
            });
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/Subject.vue